// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Page Grid */
.friends-page-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;                 /* ✅ Full viewport height */
  background: var(--card-bg, rgb(4, 4, 4));
  overflow-y: auto;              /* ✅ Vertical scrolling */
  overflow-x: hidden;            /* ✅ No horizontal scroll */
  scroll-behavior: smooth;       /* ✅ Smooth scroll animation */
}

/* Custom scrollbar styling */
.friends-page-grid::-webkit-scrollbar {
  width: 10px;
}

.friends-page-grid::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

.friends-page-grid::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.5);
  border-radius: 10px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
}

.friends-page-grid::-webkit-scrollbar-thumb:hover {
  background: rgba(102, 126, 234, 0.8);
}

/* Firefox scrollbar */
.friends-page-grid {
  scrollbar-width: thin;
  scrollbar-color: rgba(102, 126, 234, 0.5) rgba(255, 255, 255, 0.05);
}


/* Top Container - Header & Controls */
.ua-top-container {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0;
  margin: 0;
}

/* Middle Container - Content Area */
.ua-middle-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  padding: 0;
  min-height: auto;
  height: auto;
}

/* Bottom Container - Friends List */
.ua-bottom-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  min-height: 100vh;
  height: auto;
  background: black;
}

/* Central Container - Grid Layout */
.ua-central-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  padding: 20px;
  width: 100%;
}

/* Responsive Design - 4 columns on medium screens */
@media (max-width: 1400px) {
  .ua-central-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Responsive Design - 3 columns on tablets */
@media (max-width: 1024px) {
  .ua-central-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Responsive Design - 2 columns on small tablets */
@media (max-width: 768px) {
  .ua-central-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
}

/* Responsive Design - 1 column on mobile */
@media (max-width: 480px) {
  .ua-central-container {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Friends/FriendsGridLayout.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa,kBAAkB,2BAA2B;EAC1D,wCAAwC;EACxC,gBAAgB,eAAe,yBAAyB;EACxD,kBAAkB,aAAa,2BAA2B;EAC1D,uBAAuB,QAAQ,8BAA8B;AAC/D;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,mEAAmE;AACrE;;;AAGA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,iDAAiD;EACjD,UAAU;EACV,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["/* Main Page Grid */\n.friends-page-grid {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;                 /* ✅ Full viewport height */\n  background: var(--card-bg, rgb(4, 4, 4));\n  overflow-y: auto;              /* ✅ Vertical scrolling */\n  overflow-x: hidden;            /* ✅ No horizontal scroll */\n  scroll-behavior: smooth;       /* ✅ Smooth scroll animation */\n}\n\n/* Custom scrollbar styling */\n.friends-page-grid::-webkit-scrollbar {\n  width: 10px;\n}\n\n.friends-page-grid::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n}\n\n.friends-page-grid::-webkit-scrollbar-thumb {\n  background: rgba(102, 126, 234, 0.5);\n  border-radius: 10px;\n  transition: background 0.2s ease;\n}\n\n.friends-page-grid::-webkit-scrollbar-thumb:hover {\n  background: rgba(102, 126, 234, 0.8);\n}\n\n/* Firefox scrollbar */\n.friends-page-grid {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(102, 126, 234, 0.5) rgba(255, 255, 255, 0.05);\n}\n\n\n/* Top Container - Header & Controls */\n.ua-top-container {\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 0;\n  margin: 0;\n}\n\n/* Middle Container - Content Area */\n.ua-middle-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow-y: auto;\n  padding: 0;\n  min-height: auto;\n  height: auto;\n}\n\n/* Bottom Container - Friends List */\n.ua-bottom-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  min-height: 100vh;\n  height: auto;\n  background: black;\n}\n\n/* Central Container - Grid Layout */\n.ua-central-container {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n  padding: 20px;\n  width: 100%;\n}\n\n/* Responsive Design - 4 columns on medium screens */\n@media (max-width: 1400px) {\n  .ua-central-container {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* Responsive Design - 3 columns on tablets */\n@media (max-width: 1024px) {\n  .ua-central-container {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Responsive Design - 2 columns on small tablets */\n@media (max-width: 768px) {\n  .ua-central-container {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n}\n\n/* Responsive Design - 1 column on mobile */\n@media (max-width: 480px) {\n  .ua-central-container {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
